module.exports = __webpack_public_path__ + "img/kv_sp.bc3e76c.jpg";